"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition = component.has_personalization ? 'ThankYouMessage' : 'ThankYou';

  if (accumulator) {
    return accumulator + '-' + addition;
  }

  return addition;
};